module.exports = __webpack_public_path__ + "media/images/driving_school/series_thematic-35767dcbf236aa6f6855c5c4043a70fa.png";